import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Orders from '../Orders';
import Healthcheck from '../Healthcheck';
import About from '../About';
import Topbar from '../Topbar';
import Defcon from '../Defcon';
import HttpClient from "../../libs/http";
import IddleInstances from '../Ducktales/IddleInstances';
const http = new HttpClient();
let worker = null;
export default class Router extends Component {
  constructor(props) {
    super(props);
    this.state = {
      version: null
    };
    this.refreshWhenNeed = this.refreshWhenNeed.bind(this);
  }
  async componentWillMount() {
    await this.refreshWhenNeed();
    worker = setInterval(this.refreshWhenNeed, 60000);
  }
  componentWillUnmount() {
    if (worker) clearInterval(worker);
  }
  async refreshWhenNeed() {
    const _state = this.state;
    let whoami = await http.GET("/api/meta/whoami");
    if (!_state.version) {
      _state.version = whoami.version;
      this.setState(_state);
    }
    else if (_state.version !== whoami.version) {
      window.location.reload();
    }
  }
  render() {
    return (
      <BrowserRouter>
        <div>
          <Topbar />
          <Defcon />
          <Route exact path="/" component={ Orders } />
          <Route exact path="/peraccount" component={ Orders } />
          <Route exact path="/persegment" component={ Orders } />
          <Route exact path="/persquad" component={ Orders } />
          <Route exact path="/percountry" component={ Orders } />
          <Route path="/orders" component={ Orders } />
          <Route path="/healthcheck" component={ Healthcheck } />
          <Route path="/ducktales" component={ IddleInstances } />
          <Route path="/about" component={ About } />
        </div>
      </BrowserRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Router/index.js